import { InstagramTrackersApiService } from "./InstagramTrackersService";

export default InstagramTrackersApiService;
